<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>订单</el-breadcrumb-item>
    </el-breadcrumb>
    <order-list :status="100"></order-list>
  </div>
</template>

<script>
import OrderList from './list'
export default {
  components: { OrderList },
}
</script>